module.exports = __webpack_public_path__ + "static/media/1POLICY28.1f9b2439.jpg";